import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PromotionImagesResponse } from '@1po/1po-bff-fe-spec/generated/backoffice/promotion/response/PromotionImagesResponse';
import { fetchPromotionImagesRequestSaga, getSystemPromotionImages } from 'domains/promotion/Promotion.store';
import { LOADING, SearchData } from 'utils';
import CacheMap from 'utils/dataStructure/CacheMap';

// fetch cache is used because this hook is called multiple times - just prevent multiple http calls
const fetchCache = new CacheMap<string, boolean>(10000);

const loadingCacheKey = 'default-system-promotion-images-key';

export const usePromotionImages = (): SearchData<PromotionImagesResponse> => {
  const dispatch = useDispatch();

  const systemPromotionImagesFromStore = useSelector(getSystemPromotionImages);
  useEffect(() => {
    if (systemPromotionImagesFromStore === undefined && !fetchCache.has(loadingCacheKey)) {
      fetchCache.set(loadingCacheKey, true);
      dispatch(fetchPromotionImagesRequestSaga());
    }
    // eslint-disable-next-line
  }, [dispatch, systemPromotionImagesFromStore, loadingCacheKey]);
  return systemPromotionImagesFromStore ?? { searchStatus: LOADING };
};
